<script setup lang="ts">
import HomeNavigation from "@/modules/public/components/HomeNavigation.vue";
import HomeFooter from "@/modules/public/components/HomeFooter.vue";
</script>

<template>
  <v-app>
    <HomeNavigation />
    <v-main>
      <RouterView />
    </v-main>
    <HomeFooter />
  </v-app>
</template>
